import React, { useState } from 'react';
import { Restaurant } from '../types';

interface RestaurantCardProps {
  restaurant: Restaurant;
  onSelect: () => void;
  showStatus?: boolean;
}

const RestaurantCard: React.FC<RestaurantCardProps> = ({ 
  restaurant, 
  onSelect, 
  showStatus = false 
}) => {
  const isOpen = restaurant.isOpen;
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div 
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 cursor-pointer overflow-hidden"
      onClick={onSelect}
    >
      {/* Header con imagen del restaurante */}
      <div className="relative">
        <div className="h-32 bg-gradient-to-br from-[#22B6B2] to-[#1a9a96] flex items-center justify-center overflow-hidden">
          {/* Imagen del restaurante */}
          {restaurant.image && 
           restaurant.image !== 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&h=300&fit=crop&crop=center' && 
           !imageError ? (
            <img
              src={restaurant.image}
              alt={restaurant.name}
              className={`w-full h-full object-cover transition-opacity duration-300 ${
                imageLoaded ? 'opacity-100' : 'opacity-0'
              }`}
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
            />
          ) : null}
          
          {/* Fallback icono */}
          <div className={`text-4xl text-white transition-opacity duration-300 ${
            restaurant.image && 
            restaurant.image !== 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&h=300&fit=crop&crop=center' && 
            !imageError && imageLoaded ? 'opacity-0' : 'opacity-100'
          }`}>
            🏪
          </div>
        </div>
        
        {showStatus && (
          <div className="absolute top-3 right-3">
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
              isOpen 
                ? 'bg-green-100 text-green-800' 
                : 'bg-red-100 text-red-800'
            }`}>
              {isOpen ? 'Abierto' : 'Cerrado'}
            </span>
          </div>
        )}
      </div>

      {/* Contenido */}
      <div className="p-4">
        <h3 className="text-lg font-bold text-[#2C4358] mb-2">
          {restaurant.name}
        </h3>
        
        {restaurant.description && (
          <p className="text-[#85929e] text-sm mb-3 line-clamp-2">
            {restaurant.description}
          </p>
        )}

        {/* Información de contacto */}
        <div className="space-y-1">
          {restaurant.address && (
            <div className="flex items-center text-sm text-[#85929e]">
              <span className="mr-2">📍</span>
              <span className="truncate">{restaurant.address}</span>
            </div>
          )}
          
          {restaurant.phone && (
            <div className="flex items-center text-sm text-[#85929e]">
              <span className="mr-2">📞</span>
              <span>{restaurant.phone}</span>
            </div>
          )}
        </div>

        {/* Botón de acción */}
        <div className="mt-4">
          <button
            className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${
              isOpen
                ? 'bg-[#22B6B2] text-white hover:bg-[#1a9a96]'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            disabled={!isOpen}
          >
            {isOpen ? 'Ver Menú' : 'Cerrado'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantCard; 